import React from 'react';

interface CloseIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CloseIcon: React.FC<CloseIconProps> = ({ 
  width = 14, 
  height = 14, 
  color = '#0D0D0D' 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 14 14" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M12.5761 0.576127C12.8104 0.341818 13.1895 0.341829 13.4238 0.576127C13.6581 0.810441 13.6581 1.18947 13.4238 1.42378L7.84761 6.99995L13.4238 12.5761C13.6581 12.8104 13.6581 13.1895 13.4238 13.4238C13.1895 13.6581 12.8104 13.6581 12.5761 13.4238L6.99995 7.84761L1.42378 13.4238C1.18947 13.6581 0.810441 13.6581 0.576127 13.4238C0.341829 13.1895 0.341818 12.8104 0.576127 12.5761L6.1523 6.99995L0.576127 1.42378C0.341812 1.18947 0.341812 0.810441 0.576127 0.576127C0.810441 0.341812 1.18947 0.341812 1.42378 0.576127L6.99995 6.1523L12.5761 0.576127Z" 
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;

